import { getTokenAsync } from "../../hooks/API/getAuthToken";
import packageJson from "../../../../package.json";

export const atkomstHeadersBs = {
  "X-Atkomst": "bs",
};

export async function makeServiceHeaders(
  alternativeToken: string = ""
): Promise<HeadersInit> {
  const token = await getTokenAsync();
  if (!token || typeof token !== "string") {
    throw new Error("Token is not a string");
  }
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${alternativeToken ? alternativeToken : token}`,
    "X-Client-Version": packageJson.version,
    ...atkomstHeadersBs,
  };
}
